export default __webpack_public_path__ + "static/media/home-about-ape.67398ea5.svg";